<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingvmodel"></loadingcomp>



    <v-card height="100%" color="grey lighten-5" flat>
      <v-form ref="formadres" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar class="baslik" size="120px" dark color="info">
              <v-toolbar-title>{{$t('Address_label')}} </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip v-if="islem!='get'" bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Add')}}</span>
              </v-tooltip>


              <v-tooltip v-if="islem=='get'" bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="guncelle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                  <v-icon right dark>edit</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Update') }}</span>
              </v-tooltip>


              <!--
              <v-menu bottom="">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list>
                  <a target="_self" v-bind:href="'#/cari/index/'">

                    <v-list-tile>
                      <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
                <v-list>

                  <v-list-tile @click="videoac()">
                    <v-list-tile-title> {{ $t('How-to-do') }} </v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu> -->

            </v-toolbar>
          </v-flex>



          <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              {{$t("tab_general")}}
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:500px;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex xs12 md6 sm6>
                            <v-text-field :label="$t('Category')" v-model="Adres.Kategori" hide-details="">
                            </v-text-field>

                          </v-flex>


                          <v-flex xs12 md6 sm6>
                            <v-text-field label="Üye Numarası" v-model="Adres.UyeNo" hide-details="">
                            </v-text-field>
                          </v-flex>


                          <v-flex xs12 md6 sm6>
                            <v-text-field hide-details="" mask="###########" :label="$t('Identitynumber_label')" value=""
                              v-model="Adres.TCKimlikNo">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 sm6>
                            <v-select :items="itemscinsiyet" hide-details="" v-model="Adres.Cinsiyet" item-text="text"
                              item-value="value" clearable :label="$t('Sex')">
                            </v-select>
                          </v-flex>


                          <v-flex xs12 md6 sm12>
                            <v-text-field hide-details=""  :rules="[v => (!!v && v.length <= 50) || $t('Must-be-characters-maximum')]" :label="$t('Name_label')"
                              v-model="Adres.Ad">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md6 sm12>
                            <v-text-field hide-details=""  :label="$t('Surname_label')"  :rules="[v => (v == null || v.length <= 50) || $t('Must-be-characters-maximum')]"
                              v-model="Adres.Soyad">
                            </v-text-field>
                          </v-flex>


                          <v-flex xs12 md6 sm6>
                            <tarihim :etiket="$t('Date-of-Birth')" v-bind:value="Adres.DogumTarihi" :detaygizle="true"
                              v-model="Adres.DogumTarihi" v-bind:defaultvalue="'no'"></tarihim>

                          </v-flex>


                          <v-flex xs12 md6 sm6>
                            <v-text-field :label="$t('Place-Birth')" v-model="Adres.DogumYeri" hide-details="">
                            </v-text-field>
                          </v-flex>


                          <v-flex xs12 md6 sm12>
                            <v-text-field hide-details="" :label="$t('Mother-Name')" v-model="Adres.AnneAdi">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md6 sm12>
                            <v-text-field hide-details="" :label="$t('Father-Name')" v-model="Adres.BabaAdi">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md12 sm12>
                            <v-text-field hide-details="" :label="$t('Occupation')" value="" v-model="Adres.Meslek">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md4 sm4>
                            <v-text-field hide-details="" label="Tel1" value="" v-model="Adres.Telefon1">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md4 sm4>
                            <v-text-field hide-details="" label="Tel2" value="" v-model="Adres.Telefon2">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md4 sm4>
                            <v-text-field hide-details="" label="GSM" value="" v-model="Adres.GSM">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md12 sm12>
                            <v-textarea v-model="Adres.Adres" :label="$t('Address_label')"></v-textarea>
                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>


                          <v-flex xs12 sm6 md4>
                            <v-checkbox :label="$t('Requires-Online-Check-in')" v-model="Adres.OnlineCIn" hide-details></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-checkbox :label="$t('Smokes')" v-model="Adres.Sigara" hide-details></v-checkbox>
                          </v-flex>


                          <v-flex xs12 md12 sm12>
                            <v-text-field hide-details="" :label="$t('Email_label')" v-model="Adres.Email">
                            </v-text-field>
                          </v-flex>




                          <v-flex xs12 md12 sm12>
                            <v-textarea v-model="Adres.Notlar" :label="$t('Notes')"></v-textarea>
                          </v-flex>

                          <v-flex xs12 md12 sm12>
                            <v-textarea v-model="Adres.RezIstekleri" :label="$t('Reservation-Requests')"></v-textarea>
                          </v-flex>


                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>



            </v-tab-item>

            <v-tab href='#1' ripple>
              {{ $t('Passport-DETAILS') }}
            </v-tab>

            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>




                          <v-flex xs12 md6 sm12>
                            <v-select :items="itemspasaporttipi" hide-details="" v-model="Adres.PasaportTip"
                              item-text="text" item-value="value" label="Pasaport Tipi">
                            </v-select>
                          </v-flex>

                          <v-flex xs12 md6 sm12>
                            <v-text-field hide-details="" :label="$t('Passport-No')" v-model="Adres.PasaportNo">
                            </v-text-field>
                          </v-flex>

                          <v-flex xs12 md12 sm12>
                            <v-text-field hide-details="" :label="$t('Place-Issue')" v-model="Adres.VerildigiYer">
                            </v-text-field>
                          </v-flex>


                          <v-flex xs12 md6 sm6>
                            <tarihim :etiket="$t('Date-Issue')" v-bind:value="Adres.VerilisTarihi" :detaygizle="true"
                              v-model="Adres.VerilisTarihi" v-bind:defaultvalue="'no'"></tarihim>

                          </v-flex>


                          <v-flex xs12 md6 sm6>
                            <tarihim :etiket="$t('Finishing-Date')" v-bind:value="Adres.BitisTarihi" :detaygizle="true"
                              v-model="Adres.BitisTarihi" v-bind:defaultvalue="'no'"></tarihim>

                          </v-flex>






                          <v-flex xs12 md12 sm12>
                            <v-select :items="itemseskiyeni" hide-details="" v-model="Adres.EskiYeni" item-text="text"
                              item-value="value" clearable :label="$t('Passport-Old-New')">
                            </v-select>
                          </v-flex>



                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>

                </v-flex>

                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>




                          <v-flex xs12 md12 sm12>
                            <v-text-field hide-details="" mask="##################" :label="$t('Children-Address-Code')"
                              v-model="Adres.Cocuk1Kod">
                            </v-text-field>


                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-checkbox :label="$t('Passport-Includes-Children')" v-model="Adres.PspCocukVar" hide-details>
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-checkbox :label="$t('Children-Require-Visa')" v-model="Adres.PspCocukVizeIstiyor" hide-details>
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-tab-item>

      
            <v-tab href='#2' ripple>
              {{ $t('Department-v2') }}
            </v-tab>

            <v-tab-item :id="'2'" style="width:100%; height:100%;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                          <cariaracomp v-bind:etiket="$t('Cost-Current')" v-bind:value="Adres.dptCariKod.kod" v-model="Adres.dptCariKod.kod" :Coper="true"></cariaracomp>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <geneltipara v-model="Adres.dptBolge" tip="Bölge">
                            </geneltipara>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <geneltipara v-model="Adres.dptYonetim" tip="Yönetim">
                            </geneltipara>
                          </v-flex>


                          <v-flex xs12 sm12 md12>
                            <geneltipara v-model="Adres.dptDepartman" tip="Departman">
                            </geneltipara>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <geneltipara v-model="Adres.dptAltDepartman" tip="Alt Departman">
                            </geneltipara>
                          </v-flex>



                          <v-flex xs12 sm12 md12>
                            <geneltipara v-model="Adres.dptBolum" tip="Bölüm">
                            </geneltipara>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>

                </v-flex>


              </v-layout>
            </v-tab-item>


            <v-tab href='#3' ripple>
              Özel Günler
            </v-tab>

            <v-tab-item :id="'3'">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md6>
                  <v-card>
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 md12 sm12>
                            <tarihim :etiket="$t('Special-Days') + '-1'" v-bind:value="Adres.OzelGun1" :detaygizle="true"
                              v-model="Adres.OzelGun1" v-bind:defaultvalue="'no'"></tarihim>
                          </v-flex>
                          <v-flex xs12 md12 sm12>
                            <tarihim :etiket="$t('Special-Days') + '-2'" v-bind:value="Adres.OzelGun2" :detaygizle="true"
                              v-model="Adres.OzelGun2" v-bind:defaultvalue="'no'"></tarihim>
                          </v-flex>
                          <v-flex xs12 md12 sm12>
                            <tarihim :etiket="$t('Special-Days') +  ' -3'" v-bind:value="Adres.OzelGun3" :detaygizle="true"
                              v-model="Adres.OzelGun3" v-bind:defaultvalue="'no'"></tarihim>
                          </v-flex>
                          <v-flex xs12 md12 sm12>
                            <tarihim :etiket="$t('Special-Days') + ' -4'" v-bind:value="Adres.OzelGun4" :detaygizle="true"
                              v-model="Adres.OzelGun4" v-bind:defaultvalue="'no'"></tarihim>
                          </v-flex>
                          <v-flex xs12 md12 sm12>
                            <tarihim :etiket="$t('Special-Days') +  '-5'" v-bind:value="Adres.OzelGun5" :detaygizle="true"
                              v-model="Adres.OzelGun5" v-bind:defaultvalue="'no'"></tarihim>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-tab-item>


          </v-tabs>

          <v-dialog v-model="dialogfiltre" scrollable="" max-width="500px">
            <v-card flat color="grey lighten-5">

              <v-card-title> {{ $t('Term-Type-Explanations') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                <v-flex xs12 sm12 md12>
                  <v-list two-line>
                    <template v-for="(item, index) in vadetipi">
                      <v-subheader v-if="item.header" :key="item.header">

                      </v-subheader>

                      <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

                      <v-list-tile v-else :key="item.title">
                        <v-list-tile-avatar>
                          {{item.value}}
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <span class="caption"> {{item.text}}</span>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>

                </v-flex>

              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">{{$t('Close')}}</v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-layout>
      </v-form>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </v-card>
  </div>
</template>
<script>
  import auth from '../../../../api/auth'
  import parainput from '../../customcomp/parainput'
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import tool from "../../coper/tools";
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
  import loadingcomp from "@/components/app/customcomp/loadingcomp.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'

  export default {
    data() {
      return {
        islem: 'yeni',
        loadingvmodel: false,
        loadingmesaj: null,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },

        prevRoute: null,

        mukellefScroll: false,
        hesapgurubu: [],
        dialogfiltre: false,
        cokluposta: false,
        postaitems: [],
        valid: true,
        tabcontrol3: 0,
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statecari: [],
        search: '',
        search1: '',
        loading: false,


        Adres: {
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          PspOfsTeslimAlan: null,
          PspOfsTeslimTarihi: null,
          PspMusTeslimEden: null,
          PspMusTeslimTarihi: null,
          dptBolge: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptYonetim: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptDepartman: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptAltDepartman: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptBolum: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          dptCariKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          SicilID: null,
          Id: 0,
          Kategori: null,
          Ad: null,
          Soyad: null,
          Adres: null,
          DogumTarihi: null,
          Ulke: null,
          Sehir: null,
          Meslek: null,
          Telefon1: null,
          Telefon2: null,
          GSM: null,
          Email: null,
          PasaportTip: 0,
          PasaportNo: null,
          VerildigiYer: null,
          VerilisTarihi: null,
          BitisTarihi: null,
          Sigara: null,
          Notlar: null,
          USAVize: null,
          USABitis: null,
          AnneAdi: null,
          BabaAdi: null,
          TCKimlikNo: null,
          DogumYeri: null,
          Kod: 0,
          Cinsiyet: 0,
          RezIstekleri: null,
          SirketNo: null,
          UyeNo: null,
          PspCocukVar: false,
          PspCocukVizeIstiyor: false,
          Cocuk1Kod: null,
          OnlineCIn: false,
          OzelGun1: null,
          OzelGun2: null,
          OzelGun3: null,
          OzelGun4: null,
          OzelGun5: null,
          EskiYeni: null,
          Uyruk: null
        },



        itemscinsiyet: [{
            text: this.$t('Male'),
            value: 1
          },
          {
            text: this.$t('Female'),
            value: 2
          }
        ],

        itemspasaporttipi: [{
            text: 'Normal',
            value: 0
          },
          {
            text: this.$t('Green'),
            value: 1
          },
          {
            text: this.$t('Diplomatic'),
            value: 2
          },
          {
            text: this.$t('Other'),
            value: 3
          }
        ],


        itemseskiyeni: [{
            text: this.$t('Old'),
            value: 0
          },
          {
            text: this.$t('New'),
            value: 1
          }
        ],


        icYuzdedenHesapla: {
          Yuzdeden: false,
          HesapTipi: null,
          HesapYuzde: 0
        },
        DisYuzdedenHesapla: {
          Yuzdeden: false,
          HesapTipi: null,
          HesapYuzde: 0
        },


        musteritipi: [{
            text: this.$t('Individual'),
            value: 'B'
          },
          {
            text: this.$t('Corporate'),
            value: 'K'
          }, {
            text: this.$t('Public'),
            value: 'Ka'
          },

        ],
        efaturatipi: [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          }
        ],
        islembilgileri: [{
            text: this.$t('Hard-Copy-Invoice'),
            value: 'false'
          },
          {
            text: this.$t('Electronic-Invoice'),
            value: 'true'
          }
        ],
        cmkodu: [
          'C', 'M'
        ],
        doviztipi: [],


        vadetipi: [{
            value: 'D',
            text: this.$t('transfer-date-lesser-than-transfer-date-day')

          },

          {
            value: 'D+',
            text: this.$t('transfer-date-lesser-transfer-date-greater-day')

          },

          {
            value: 'D-',
            text: this.$t('transfer-date-lesser-transfer-date-greater-day')
          },
          {
            value: 'E',
            text: this.$t('transfer-date-lesser-day-next-month-greater')
          },
          {
            value: 'E+',
            text: this.$t('day-the-first-month-number-entered-days')
          },
          {
            value: 'E-',
            text: this.$t('first-month-number-entered-days')
          },


          {
            value: 'K',
            text: this.$t('day-first-month')
          },
          {
            value: 'K+',
            text: this.$t('month-number-entered-days')
          },
          {
            value: 'K-',
            text: this.$t('month-number-entered-days-minus')
          },
          {
            value: 'L',
            text: this.$t('day-first-month-twenty')
          }, {
            value: 'L-',
            text: this.$t('the-first-month-number-entered-days')
          }, {
            value: 'L+',
            text: this.$t('first-month-number-entered-days-v2')
          }, {
            value: 'M',
            text: this.$t('day-of-the-first-month')
          }, {
            value: 'M+',
            text: this.$t('first-month-number-entered-days-v3')
          }, {
            value: 'M-',
            text: this.$t('first-month-number-entered-days-v4')
          },
          {
            value: 'R',
            text: this.$t('day-of-if-the-transfer')
          },
          {
            value: 'R+',
            text: this.$t('entered-days-date-lesser-than-day')
          },
          {
            value: 'R-',
            text: this.$t('entered-days-date-lesser-than-day')
          }, {
            value: 'S',
            text: this.$t('transfer-date-lesser-dayday')
          }, {
            value: 'S+',
            text: this.$t('number-date-lesser-than-day')
          }, {
            value: 'S-',
            text: this.$t('number-date-lesser-than-day')
          }, {
            value: 'V',
            text: this.$t('day-of-the-next-month')
          }, {
            value: 'V+',
            text: this.$t('next-month-number-entered-days')
          }, {
            value: 'V-',
            text: this.$t('next-month-number-entered-days-v2')
          }
        ],
        evethayir: [{
            text: 'Evet',
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],
        masrafmerkezi: [],

        autocomplete: 'autocomplete',
        tutar: 'tutar',
        etikettutar: 'Tutar',
        defaultvalue: 0,
        nameRules: [
          (v) => v && v.length <= 25 || 'max 25 karakter'
        ],

        emailRules: [
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail formatı uygun değil'
        ],


        dictionary: {
          custom: {
            carikod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            unvan: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },

          }
        },

        StartDate: null,
        EndDate: null,
        NumberOfPolicies: '',
        PolicySum: '',
        TotalDebt: '',
        TotalFlatDebt: '',
        kaydetbuton: false,

        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        text1: '',
        ichatdoviztipi1: false,
        ichatdoviztipi2: false,
        ichatdoviztipi3: false,
        ichatdoviztipi4: false,
        ichatdoviztipi5: false,
        dishatdoviztipi1: false,
        dishatdoviztipi2: false,
        dishatdoviztipi3: false,
        dishatdoviztipi4: false,
        dishatdoviztipi5: false,
        dishatdoviztipi6: false,
        dishatdoviztipi7: false,
        biletlerfaturalanmasin: null,
        efaturamukellefi: false,
        Kdvmuaf: null,
        ciktiistemiyor: null,
        musteribilgitipi: null,
        profilzorunlu: null,
        eventidzorunlu: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        ex11: 'false',

        icyuzde: false,
        disyuzde: false
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },

    mounted() {
      this.$validator.localize('en', this.dictionary)


      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        if (this.$route.query.isl == 'get') {
          this.islem = 'get'


          if (this.$route.query.id != null && this.$route.query.id != undefined) {
            this.loadingvmodel = true

            let params = {
              Id: this.$route.query.id
            }

            tool.http_post(this, 'AdresLoad', params).then(
              response => {
                this.loadingvmodel = false

                if (response.body.Status == true) {
                  this.Adres = response.body.data
                } else {
                  this.text1 = response.body.ErrorList[0]
                  this.snackbar = true
                }
              },
              response => {
                this.loadingvmodel = false

                this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                this.snackbar = true
              }

            );
          } else {

            this.text1 = 'Hatalı işlem id boş olamaz'
            this.snackbar = true

          }

        } else {
          this.islem = 'yeni'
        }





      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });

      }

    },
    methods: {
      videoac() {
        this.videodialog = true
      },
      soncarikoduGetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var current = {
          CompanyCode: credentials.SirketKodu,
          Text: this.Current.Code
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetLastCurrent', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.Current.Code = response.body
        }, (response) => {

          this.text1 = 'Kod getirilemedi, tekrar deneyiniz.'
          this.snackbar = true

        })

      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      mukellefSorgula() {
        if (this.$refs.vergino.validate()) {
          this.mukellefScroll = true

          var prm = {
            VKN: this.Current.Invoice.TaxNumber //9240492097
          }

          tool.api_post(this, "EFatura/VKN_Sorgula", prm).then(

            response => {
              this.mukellefScroll = false

              this.postaitems = []

              if (response.body.length > 0) {
                this.efaturamukellefi = true

                if (response.body.length > 1) {

                  this.cokluposta = true
                  response.body.forEach(element => {
                    this.postaitems.push(element.alias)
                  });
                  this.Current.PostCodeLabel = response.body[0].alias
                } else {
                  this.cokluposta = false
                  this.Current.PostCodeLabel = response.body[0].alias

                }

              } else {
                this.text1 = this.$t('No-liable-found')
                this.snackbar = true
              }

            },
            response => {
              this.status = tool.responseToStatus(response);
              this.mukellefScroll = false
            }
          );

        } else {
          this.text1 = this.$t('Please-Enter-Your-Digit-Taxation-Number');
          this.snackbar = true
        }

      },
      ekle: ekle,
      guncelle,
      getDateNow: getDateNow,
      onChangecheck: onChangecheck,
      onChangecheckdis: onChangecheckdis,
      karsidegeral: karsidegeral
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      yuzdeinput,
      tarihim,
      yetkidialog,
      genelarama,
      geneltipara,
      loadingcomp,
      cariaracomp
    },
    watch: {

    }
  }

  function karsidegeral(val) {
    if (val == true) {
      return false
    } else if (val == false) {
      return false
    }
  }

  function onChangecheck(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.ichatdoviztipi1 == true && nerden != 'ichatdoviztipi1') {
      this.ichatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi2 === true && nerden != 'ichatdoviztipi2') {
      this.ichatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi3 === true && nerden != 'ichatdoviztipi3') {
      this.ichatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi4 === true && nerden != 'ichatdoviztipi4') {
      this.ichatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi5 === true && nerden != 'ichatdoviztipi5') {
      this.ichatdoviztipi5 = karsidegeral(elem1)
    }
  }

  function onChangecheckdis(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.dishatdoviztipi1 == true && nerden != 'dishatdoviztipi1') {
      this.dishatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi2 === true && nerden != 'dishatdoviztipi2') {
      this.dishatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi3 === true && nerden != 'dishatdoviztipi3') {
      this.dishatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi4 === true && nerden != 'dishatdoviztipi4') {
      this.dishatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi5 === true && nerden != 'dishatdoviztipi5') {
      this.dishatdoviztipi5 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi6 === true && nerden != 'dishatdoviztipi6') {
      this.dishatdoviztipi6 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi7 === true && nerden != 'dishatdoviztipi7') {
      this.dishatdoviztipi7 = karsidegeral(elem1)
    }
  }

  function beforeMount() {


  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function ekle() {

    if (this.$refs.formadres.validate()) {
      this.loadingcomp = true
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.Adres.SirketNo = credentials.CoperSirketNo
      var params = {
        Value: this.Adres
      }
      tool.http_post(this, 'AdresInsert', params).then(
        response => {
          this.loadingcomp = false
          if (response.body.Status == true) {
            this.text1 = 'Kayıt Eklendi'
            this.snackbar = true
                        this.Adres=this.response.body.data

          } else {
            this.text1 = response.body.ErrorList[0]
            this.snackbar = true
          }
        },
        response => {
          this.loadingcomp = false

          this.text1 = 'Hata Oluştu, tekrar deneyiniz'
          this.snackbar = true
        }
      );
    } else {
      this.active = 0
    }
  }

  function guncelle() {

    if (this.$refs.formadres.validate()) {
      this.loadingvmodel = true
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.Adres.SirketNo = credentials.CoperSirketNo
      var params = {
        Value: this.Adres
      }
      tool.http_post(this, 'AdresUpdate', params).then(
        response => {
          this.loadingvmodel = false
          if (response.body.Status == true) {
         this.text1 = 'Kayıt Güncellendi'
            this.snackbar = true
            this.Adres=this.response.body.data
          } else {
            this.text1 = response.body.ErrorList[0]
            this.snackbar = true
          }
        },
        response => {
          this.loadingvmodel = false

          this.text1 = 'Hata Oluştu, tekrar deneyiniz'
          this.snackbar = true
        }
      );
    } else {
      this.active = 0
    }
  }
</script>

<style>
</style>